import { rootApi } from "../../api/rootApi";

export const mediaApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    addMedia: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/media/add`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    getAllMedia: builder.mutation({
      query: (params) => {
        return {
          method: "POST",
          url: `/tenant/media`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),

    getMediaById: builder.query({
      query: (params) => {
        return {
          method: "GET",
          url: `/tenant/media/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    updateMedia: builder.mutation({
      query: (params) => {
        return {
          method: "PUT",
          url: `/tenant/media/${params.id}`,
          headers: {
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
    deleteMedia: builder.mutation({
      query: (params) => {
        return {
          method: "DELETE",
          url: `/tenant/media/${params.id}`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
        };
      },
    }),

    mediaSequenceUpdate: builder.mutation({
      query: (params) => {
        return {
          method: "PATCH",
          url: `/tenant/media/sequence`,
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + params.token,
            slug: params.tenant_id,
          },
          body: params.body,
        };
      },
    }),
  }),
});

export const {
  useAddMediaMutation,
  useGetAllMediaMutation,
  useGetMediaByIdQuery,
  useUpdateMediaMutation,
  useDeleteMediaMutation,
  useMediaSequenceUpdateMutation,
} = mediaApi;
